export const validateTextField = value => {
  const trimmedValue = value.trim();
  if (trimmedValue?.length === 0) {
    return false;
  } else {
    return true;
  }
};
